import { useIntl } from "react-intl";

import Radio from "components/v2/Radio/Radio";
import { NotifyPartySyncOption } from "pages/shipper/RequestFormV2/defaults/notifyPartyDefaults";
import { NotifyPartySyncSlice } from "@RequestFormV2/sections/Schedule/hooks/useNotifyPartySync";
import { getNotifyPartySyncOptions } from "@RequestFormV2/sections/Schedule/utils/notifyPartyOptions";

interface NotifyPartySyncFieldProps {
  sync: NotifyPartySyncSlice;
}

export default function NotifyPartySyncField({ sync }: NotifyPartySyncFieldProps) {
  const intl = useIntl();
  const { sameAsAddressContact, handleSyncOptionChange } = sync;

  const options = getNotifyPartySyncOptions(intl);

  return (
    <div className="rfv2-schedule-notify-party__sync-options">
      <Radio
        size="md"
        options={options}
        value={sameAsAddressContact}
        onChange={(val) => handleSyncOptionChange(val as NotifyPartySyncOption)}
      />
    </div>
  );
}
